import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig'; // Adjust if your Layout folder depth is different

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const THEME_COLOR = '#065f46';

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchCategories = async () => {
            try {
                const res = await axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES);
                setCategories(res.data || []);
            } catch (error) {
                console.error("Error fetching categories", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    const getFullImageUrl = (path) => {
        if (!path) return 'https://placehold.co/300x300?text=No+Image';
        if (path.startsWith('http')) return path;
        const baseUrl = config.APIACTIVEURL.replace('/api/', '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${cleanPath}`;
    };

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px', paddingBottom: '80px' }}>
            <div className="container">
                {/* Navigation Back */}
                <div className="mb-4">
                    <Link to="/" className="text-decoration-none fw-bold" style={{ color: THEME_COLOR }}>
                        <i className="ri-arrow-left-line me-1"></i> Back to Home
                    </Link>
                </div>

                <div className="mb-5">
                    <h1 className="display-5 fw-bold mb-2" style={{ color: '#064e3b' }}>All Categories</h1>
                    <p className="text-muted fs-5">Select a category to find the best salons and services.</p>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border" style={{ color: THEME_COLOR }} role="status"></div>
                        <p className="mt-3 text-muted">Loading categories...</p>
                    </div>
                ) : (
                    <div className="row g-4">
                        {categories.map(cat => (
                            <div className="col-6 col-md-4 col-lg-3 col-xl-2" key={cat.categoryId}>
                                <div 
                                    className="card border-0 shadow-sm h-100 text-center p-3" 
                                    style={{ 
                                        borderRadius: '1.5rem', 
                                        cursor: 'pointer', 
                                        transition: 'all 0.3s ease-in-out',
                                        backgroundColor: '#fff'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-10px)';
                                        e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                    /* This matches your SalonByCategory route requirements */
                                    onClick={() => navigate(`/salons-by-category/${cat.categoryId}/${encodeURIComponent(cat.name)}`)}
                                >
                                    <div className="d-flex align-items-center justify-content-center mb-3" style={{ height: '90px' }}>
                                        <img 
                                            src={getFullImageUrl(cat.imageSrc)} 
                                            alt={cat.name} 
                                            className="rounded-circle shadow-sm" 
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', border: '3px solid #f0fdf4' }} 
                                        />
                                    </div>
                                    <h6 className="fw-bold mb-0" style={{ fontSize: '0.95rem', color: '#064e3b', lineHeight: '1.2' }}>
                                        {cat.name}
                                    </h6>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Categories;